import { render } from "./ActionBanner.vue?vue&type=template&id=4ceef6d8"
import script from "./ActionBanner.vue?vue&type=script&lang=js"
export * from "./ActionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__